import styled from 'styled-components';
import { HighlightedText } from '@frameio/shared/components';
import { theme } from '@frameio/vapor';
import { IconCheckmark, IconWorkspace } from '@frameio/vapor-icons';

export const WorkspaceRow = ({
  label,
  selected,
  searchQuery = '',
}: {
  label: string;
  selected: boolean;
  searchQuery?: string;
}) => {
  return (
    <RowContent>
      <StyledWorkspaceIcon size={16} />
      <LabelContainer>
        <HighlightedText
          enableTooltip={true}
          highlightText={searchQuery}
          textAlign="left"
          truncate={true}
        >
          {label}
        </HighlightedText>
      </LabelContainer>
      {selected && <StyledCheckmarkIcon size={16} />}
    </RowContent>
  );
};

export const ICON_SIZE = 20;

const RowContent = styled.div`
  align-items: center;
  border-radius: ${theme.radii[4]};
  display: flex;
  flex-direction: row;
  gap: ${theme.spaces[12]};
  margin: 0 ${theme.spaces[4]};
  padding: ${theme.spaces[4]};

  @media (hover: hover) {
    &:hover {
      background-color: ${theme.colors.background.interactive.hover};
    }
  }
`;

const LabelContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

const StyledWorkspaceIcon = styled(IconWorkspace)`
  background-color: ${theme.colors.background.interactive.activated};
  border-radius: ${theme.radii[4]};
  color: ${theme.colors.icon.primary};
  height: ${ICON_SIZE}px;
  min-width: ${ICON_SIZE}px;
  padding: ${theme.spaces[2]};
`;

const StyledCheckmarkIcon = styled(IconCheckmark)`
  color: ${theme.colors.brand.primary};
`;
